import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Env} from '../env';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {Slider} from '../models/slider';
import {SliderDto} from '../dto/slider.dto';

@Injectable()
export class SliderService {

  constructor(private http: HttpClient, private global: Env) {}

  list(): Observable<Slider[]> {
    const url = this.global.slider;
    return this.http.get(url).map((res: Slider[]) => {
      return res;
    });
  }

  get(id: number): Observable<Slider> {
    const url = this.global.slider + '/' + id;
    return this.http.get(url).map((res: Slider) => {
      return res;
    });
  }

  /*create(dto: SliderDto): Observable<Slider> {
    const url = this.global.slider;
    return this.http.post(url, JSON.stringify(dto)).map((res: Slider) => {
      return res;
    });
  }*/

  create( logo:String , title:String  , message:string ){
    console.log(logo,title,message);
    const url = this.global.slider;
    return this.http.post(url , {  image: logo, message: message  , title: title } ).map( (res:Slider) => {
      return res;
    });
  }

  /*update(id: number, dto: SliderDto): Observable<Slider> {
    const url = this.global.slider + '/' + id;
    return this.http.post(url, JSON.stringify(dto)).map((res: Slider) => {
      return res;
    });
  }*/

  update(id: number, logo:string ,  title:string , message:string ): Observable<Slider> {
    const url = this.global.slider + '/' + id;
    return this.http.post(url, {  image: logo, message: message  , title: title } ).map((res: Slider) => {
      return res;
    });
  }

  delete(id: number): Observable<Slider> {
    const url = this.global.slider + '/' + id;
    return this.http.delete(url).map((res: Slider) => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/slider.service.ts